// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" width=\"20px\" height=\"20px\" fill=\"%2344546f\" viewBox=\"0 0 20 20\"><path d=\"M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" width=\"20px\" height=\"20px\" fill=\"%239fadbc\" viewBox=\"0 0 20 20\"><path d=\"M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z\" /></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XW4IBQ2O_bZYo6 {
  color: var(--ds-text, #172b4d);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.XW4IBQ2O_bZYo6:focus {
  outline: none;
}
.t3Ou6F9HZxP3VK {
  min-height: 36px;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #dfe1e6);
  border-radius: 3px;
  -webkit-appearance: none;
  border: none;
  width: 100%;
  padding-left: 12px;
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
html[data-color-mode='dark'] .t3Ou6F9HZxP3VK {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.mzAG1EQfmzoM_C {
  min-height: 24px;
}
.F2NieNfbC1y5xt {
  background-color: var(--ds-background-neutral, #091e420f);
  box-shadow: none;
}
.t3Ou6F9HZxP3VK:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  cursor: pointer;
}
.T8GePZ_c7MnPnX,
.t3Ou6F9HZxP3VK:focus {
  background-color: var(--ds-background-input-pressed, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #0079bf);
}
.T8GePZ_c7MnPnX:hover,
.t3Ou6F9HZxP3VK:focus:hover {
  background-color: var(--ds-background-input-pressed, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #0079bf);
}
.RemDHTxCucbUNx {
  color: var(--ds-text-disabled, #091e424f);
  pointer-events: none;
  background-color: var(--ds-background-disabled, #091e4208);
}
.tvuNsho3EmuB7k {
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.KumYvzNhMLUiSl {
  background-color: var(--ds-background-selected-pressed, #85b8ff);
}
.FABqFvyoL9OMpC.t8zpoHl5bebU4w {
  color: var(--ds-text-disabled, #091e424f);
  pointer-events: none;
  background-color: var(--ds-background-disabled, #091e4208);
}
.hbmmaiYsXgBwMR {
  color: var(--ds-text-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e9f2ff);
}
.hbmmaiYsXgBwMR li {
  color: var(--ds-text-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e9f2ff);
}
.hbmmaiYsXgBwMR:hover,
.hbmmaiYsXgBwMR:active,
.hbmmaiYsXgBwMR li:active {
  color: var(--ds-text-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e9f2ff);
}
.Vsh5hj5K7Qm2_F {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: 2px;
  display: block;
}
.ZxIwUuKF1NFZ4u {
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  text-overflow: ellipsis;
  display: block;
}
.Xom592GnKJpaH8 {
  color: var(--ds-text, #172b4d);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  min-height: 36px;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #dfe1e6);
  border-radius: 3px;
  -webkit-appearance: none;
  border: none;
  width: 100%;
  padding-left: 12px;
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.Xom592GnKJpaH8:focus {
  outline: none;
}
html[data-color-mode='dark'] .Xom592GnKJpaH8 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.Xom592GnKJpaH8:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  cursor: pointer;
}
.Xom592GnKJpaH8:focus {
  background-color: var(--ds-background-input-pressed, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #0079bf);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nch-select": `XW4IBQ2O_bZYo6`,
	"nch-select__control": `t3Ou6F9HZxP3VK`,
	"nch-select__control--compact": `mzAG1EQfmzoM_C`,
	"nch-select__control--subtle": `F2NieNfbC1y5xt`,
	"nch-select__control--focus": `T8GePZ_c7MnPnX`,
	"nch-select__control--disabled": `RemDHTxCucbUNx`,
	"nch-select__menu": `tvuNsho3EmuB7k`,
	"nch-select__option--active": `KumYvzNhMLUiSl`,
	"nch-select__option": `FABqFvyoL9OMpC`,
	"nch-select__option--disabled": `t8zpoHl5bebU4w`,
	"nch-select__option--selected": `hbmmaiYsXgBwMR`,
	"nch-select__label": `Vsh5hj5K7Qm2_F`,
	"nch-select__val": `ZxIwUuKF1NFZ4u`,
	"nch-select--static": `Xom592GnKJpaH8`
};
export default ___CSS_LOADER_EXPORT___;
